window.addEventListener('load', function() {
    initSwiper();
    openMenuHandler();
    closeMenuHandler(); 
    fadeInAnimation();
    anchorHandle();
    whatsappButtonHandler();
});


/**  
This function handles the 
open menu action
*/
function  openMenuHandler() {
    const toggleButton = document.querySelector(".c-nav__toggle");
    const navMenu = document.querySelector('.js-nav__menu')
    if(toggleButton){
        toggleButton.addEventListener("click", (event) => {
            navMenu.classList.add('is-open')
        })
    }
}

/**  
This function handles the 
open menu action
*/
function  closeMenuHandler() {
    const closeButton = document.querySelector(".c-nav__close");
    const navMenu = document.querySelector('.js-nav__menu')
    if(closeButton){
        closeButton.addEventListener("click", (event) => {
            navMenu.classList.remove('is-open')
        })
    }
}

/**  
This function handles the fade animation 
open menu action
*/
function fadeInAnimation(){
    const sections = document.querySelectorAll('.fade');
    // Function to check if the section is in the viewport
    function checkVisibility() {
        sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            if (window.location.href.includes('post.php?post=8&action=edit')) {
                section.classList.add('visible');
            }
            if (rect.top  >= 0 && rect.bottom <= window.innerHeight +300) {
                section.classList.add('visible');
            }
        });
    }
    // Check visibility on page load and whenever the page is scrolled
    window.addEventListener('scroll', checkVisibility);
    checkVisibility(); // Initial check in case the section is already in the viewport
}


/**  
This function initiates swiper
open menu action
*/
function initSwiper(){
    const swiper = new Swiper('.swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 3000,
        },
        pauseOnMouseEnter:true,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      
        // And if we need scrollbar
        scrollbar: {
          hide: true
        },
    });
}

/**  
This function handles the scrollup element 
open menu action
*/
function scrollHandle() {
    try {
        let scroll = document.querySelector('.js-scrollup')
        if(scroll){
            window.addEventListener('scroll', function() {
                if (window.pageYOffset > 350) {
                scroll.classList.add('is-active')
                } else {
                scroll.classList.remove('is-active')
                }
            })
            scroll.addEventListener("click", () => {
                window.scrollTo({ top: 0, behavior: 'smooth' })
            })
        }
    } catch (error) {
      console.log(error)
    }
}


/**  
This function handles the floating whatsapp button 
open menu action
*/
function whatsappButtonHandler() {
    try {
        let button = document.querySelector('.whatsapp--float')
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 350) {
                button.classList.add('is-active')
            } else {
                button.classList.remove('is-active')
            }
        })
    } catch (error) {
      console.log(error)
    }
}


function anchorHandle(){
    let anchors = document.querySelectorAll("a");
    anchors.forEach( (anchor)=> {
        let menuItem = anchor.closest(".menu-item")?.outerHTML?.toString();
        if(menuItem){
            anchor.addEventListener("click", (e) => {
                e.preventDefault(); // Prevent the default anchor link behavior
                const menuMobile = document.querySelector(".js-nav__menu");
                if(menuMobile){
                    menuMobile.classList.remove('is-open')
                }
                const targetId = anchor.getAttribute("href").substring(1);
                console.log(targetId)
                const targetElement = document.getElementById(targetId);
                // Scroll to the section with an offset of -130px
                window.scrollTo({
                    top: targetElement.offsetTop - 150,
                    behavior: "smooth" // Smooth scroll
                });
            })
        }
    })
}
